import { render, staticRenderFns } from "./AthleteSearchSuggestion.vue?vue&type=template&id=259bf803&"
import script from "./AthleteSearchSuggestion.vue?vue&type=script&lang=ts&"
export * from "./AthleteSearchSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports